import { putJson } from '#/utils/http/putJson';

import type { UserDashboardApiSavedSearch } from './types/UserDashboardApiSavedSearch';

export async function userDashboardApiUpdateSavedSearch(
  id: string,
  { name, notifyByEmail }: { name: string; notifyByEmail: boolean },
): Promise<UserDashboardApiSavedSearch> {
  const { savedSearch } = await putJson<{
    savedSearch: UserDashboardApiSavedSearch;
  }>(`/data/saved-searches/${id}`, { name, notifyByEmail });

  return savedSearch;
}
